/**
 * Configurações da página — título, categoria, classificação, SEO, medição e
 * cores. Vive num modal do editor; este arquivo é só o conteúdo dele.
 */

import { pixelsDaConfig, type ConfigMedicao, type PaginaLanding } from '@egba-do/shared'

import type { Categoria } from '../../api/cliente'
import { CartaoCompartilhamento } from '../../componentes/landing/CartaoCompartilhamento'
import { PixelsDaPagina } from '../../componentes/landing/PixelsDaPagina'
import { Campo, Selecao } from '../../componentes/ui'
import type { LandingPagina } from './tipos'

export interface ConfigPaginaProps {
  pagina: LandingPagina
  paraRender: PaginaLanding
  categorias: Categoria[]
  medicao: ConfigMedicao | null
  onAlterar: (mudanca: Partial<LandingPagina>) => void
}

export function ConfigPagina({ pagina, paraRender, categorias, medicao, onAlterar }: ConfigPaginaProps) {
  return (
    <div className="space-y-4">
      <Campo
        rotulo="Título"
        value={pagina.titulo}
        onChange={(e) => onAlterar({ titulo: e.target.value })}
      />
      <Selecao
        rotulo="Categoria"
        value={pagina.categoriaId ?? ''}
        onChange={(e) => onAlterar({ categoriaId: e.target.value || null })}
        opcoes={[
          { valor: '', texto: 'Sem categoria' },
          ...categorias.map((c) => ({ valor: c.id, texto: c.nome })),
        ]}
      />
      <Selecao
        rotulo="Classificação da peça"
        value={pagina.classeComunicacao}
        onChange={(e) => onAlterar({ classeComunicacao: e.target.value })}
        opcoes={[
          { valor: 'obrigacional', texto: 'Obrigacional — avisa sobre obrigação legal' },
          { valor: 'transacional', texto: 'Transacional' },
          { valor: 'institucional', texto: 'Institucional' },
          { valor: 'promocional', texto: 'Promocional' },
        ]}
        ajuda="Institucional e promocional ficam bloqueadas na janela eleitoral."
      />
      <Campo
        rotulo="Descrição para buscadores"
        value={pagina.seo?.descricao ?? ''}
        onChange={(e) => onAlterar({ seo: { ...pagina.seo, descricao: e.target.value } })}
        ajuda={`${(pagina.seo?.descricao ?? '').length}/160 caracteres — é o que aparece no Google e no card do WhatsApp.`}
      />

      {/* Prévia do card: quem escreve a descrição não imagina como ela vai
          aparecer recortada num aplicativo de mensagem. Mostrar resolve. */}
      <div>
        <p className="rotulo">Como o link aparece ao ser compartilhado</p>
        <CartaoCompartilhamento pagina={paraRender} />
      </div>

      <div className="border-t border-[color:var(--color-borda-suave)] pt-4">
        <p className="rotulo">Medição e remarketing</p>
        <PixelsDaPagina
          pixels={pagina.pixels ?? []}
          daConta={pixelsDaConfig(medicao)}
          onAlterar={(pixels) => onAlterar({ pixels })}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Campo
          rotulo="Cor principal"
          type="color"
          value={pagina.tema?.corPrimaria ?? '#0c64b0'}
          onChange={(e) => onAlterar({ tema: { ...pagina.tema, corPrimaria: e.target.value } })}
        />
        <Campo
          rotulo="Cor do botão"
          type="color"
          value={pagina.tema?.corAcao ?? '#ff6b35'}
          onChange={(e) => onAlterar({ tema: { ...pagina.tema, corAcao: e.target.value } })}
        />
      </div>
    </div>
  )
}
